import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  AppsCellRendererComponent,
  ButtonCellRendererComponent,
  ButtonTextCellRendererComponent,
  CheckboxCellRendererComponent,
  ClickEditCellRendererComponent,
  DataSizeCellRendererComponent,
  DateCellRendererComponent,
  DefaultCellRendererComponent,
  DotCellRendererComponent,
  DotMenuCellRendererComponent,
  IconCellRendererComponent,
  IconImageCellRendererComponent,
  LabelIconRendererComponent,
  LinkCellRendererComponent,
  NumberCellRendererComponent,
  NumberFormatCellRendererComponent,
  PathCellRendererComponent,
  PercentageCellRendererComponent,
  ProgressBarCellRendererComponent,
  RadioButtonCellRendererComponent,
  StatusCellRendererComponent,
  StringCellRendererComponent,
  TimeCellRendererComponent,
} from './renderers';

import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from '@nx-fe/button';
import { SvgIconsModule } from '@nx-fe/icons';
import { OverflowSpanModule } from '@nx-fe/overflow-span';
import { PipesModule } from '@nx-fe/pipes';
import { ProgressBarModule } from '@nx-fe/progress-bar';
import { ToggleModule } from '@nx-fe/toggle';
import { IconsLiteModule } from '@soti/icons-lite';
import { PopupModule } from '@soti/popup';
import { SelectModule } from '@soti/select';
import { TooltipModule } from '@soti/tooltip';
import { IconContainerComponent } from '../icon-container/icon-container.component';
import { ToggleButtonCellRendererComponent } from './toggle-button-cell-renderer/toggle-button-cell-renderer.component';
import { DatePickerModule } from '@nx-fe/date-picker';
import { MoreActionsCellRendererComponent } from './more-actions-cell-renderer/more-actions-cell-renderer.component';
import { MatCheckbox } from '@angular/material/checkbox';
@NgModule({
  imports: [
    CommonModule,
    DatePickerModule,
    IconsLiteModule,
    PopupModule,
    ButtonModule,
    ProgressBarModule,
    OverflowSpanModule,
    TooltipModule,
    MatTooltipModule,
    SvgIconsModule,
    MatMenuModule,
    MatSelectModule,
    ToggleModule,
    SelectModule,
    PipesModule,
    MatCheckbox,
  ],
  declarations: [
    AppsCellRendererComponent,
    CheckboxCellRendererComponent,
    DataSizeCellRendererComponent,
    DateCellRendererComponent,
    DefaultCellRendererComponent,
    DotCellRendererComponent,
    IconCellRendererComponent,
    IconImageCellRendererComponent,
    LabelIconRendererComponent,
    LinkCellRendererComponent,
    NumberCellRendererComponent,
    NumberFormatCellRendererComponent,
    PathCellRendererComponent,
    PercentageCellRendererComponent,
    ProgressBarCellRendererComponent,
    RadioButtonCellRendererComponent,
    StatusCellRendererComponent,
    StringCellRendererComponent,
    IconContainerComponent,
    DotMenuCellRendererComponent,
    ClickEditCellRendererComponent,
    ButtonCellRendererComponent,
    ToggleButtonCellRendererComponent,
    ButtonTextCellRendererComponent,
    TimeCellRendererComponent,
    MoreActionsCellRendererComponent,
  ],
  exports: [
    AppsCellRendererComponent,
    CheckboxCellRendererComponent,
    DataSizeCellRendererComponent,
    DateCellRendererComponent,
    DefaultCellRendererComponent,
    DotCellRendererComponent,
    IconCellRendererComponent,
    IconImageCellRendererComponent,
    LabelIconRendererComponent,
    LinkCellRendererComponent,
    NumberCellRendererComponent,
    NumberFormatCellRendererComponent,
    PathCellRendererComponent,
    PercentageCellRendererComponent,
    ProgressBarCellRendererComponent,
    RadioButtonCellRendererComponent,
    StatusCellRendererComponent,
    StringCellRendererComponent,
    IconContainerComponent,
    ClickEditCellRendererComponent,
    ButtonCellRendererComponent,
    ToggleButtonCellRendererComponent,
    ButtonTextCellRendererComponent,
    TimeCellRendererComponent,
    MoreActionsCellRendererComponent,
  ],
})
export class SharedRenderersModule {}
